import React from 'react'
import { StakingBackground } from '../common/StakingBackground'

export function SwETHBackground() {
  return <StakingBackground />
}
